import { render, staticRenderFns } from "./ComfirmPaymentPage.vue?vue&type=template&id=c9d5d29a&scoped=true"
import script from "./ComfirmPaymentPage.vue?vue&type=script&lang=js"
export * from "./ComfirmPaymentPage.vue?vue&type=script&lang=js"
import style0 from "./ComfirmPaymentPage.vue?vue&type=style&index=0&id=c9d5d29a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d5d29a",
  null
  
)

export default component.exports